import Badge from '@cloudscape-design/components/badge';
import { PPartStatusMap } from '@parallel-fluidics/shared/constants';
import PropTypes from 'prop-types';
import React from 'react';

export default function PPartStatusBadge({ status }) {
  return (
    <Badge color={PPartStatusMap[status]?.color || 'grey'}>
      {status}
    </Badge>
  );
}
PPartStatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
};
